export default "__VITE_ASSET__C26Y6WSu__"